import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {defineAsyncComponent, ref} from 'vue';
  import httpRequest from '@/bps/utilities/js/httpRequest/httpRequest';

  
  declare global {
    interface Window { sidePanel: Function; }
  }

export default /*@__PURE__*/_defineComponent({
  __name: 'globalSidePanel',
  setup(__props) {

  const SidePanel = defineAsyncComponent(() => import('@/bps/components/sidePanel/SidePanel.vue'));
  const DynamicTemplate = defineAsyncComponent(() => import('@/bps/components/dynamicTemplate/dynamicTemplate.vue'));

  // Global function, accessible from everywhere (<a href="javascript:sidePanel('https://someUrl/', 'class1 class2')">)
  window.sidePanel = (url: string, additionalClasses: string = '') => {
    customClasses.value = additionalClasses;
    loadContentFromUrl(url);
  };

  const content = ref('');
  const isInitialized = ref(false);
  const isVisible = ref(false);
  const customClasses = ref('');

  function loadContentFromUrl(url: string) {
    isInitialized.value = true;
    isVisible.value = true;
    content.value = '<div class="loader"></div>';

    httpRequest.get(url)
      .then(response => {
        content.value = response.data;
      })
      .catch()
      .finally();
  }

return (_ctx: any,_cache: any) => {
  return (isInitialized.value)
    ? (_openBlock(), _createBlock(_unref(SidePanel), {
        key: 0,
        class: _normalizeClass(['global-side-panel', customClasses.value]),
        "is-visible": isVisible.value,
        onCloseSidePanel: _cache[0] || (_cache[0] = ($event: any) => (isVisible.value = false))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DynamicTemplate), { html: content.value }, null, 8 /* PROPS */, ["html"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["class", "is-visible"]))
    : _createCommentVNode("v-if", true)
}
}

})